<div class="p-listbox p-component" [class]="class">
	<div class="p-listbox-header p-2">
		<ms-input-text
			class="w-full"
			iconLeft="pi pi-search"
			placeholder="Estou procurando..."
			[formGroup]="formGroup"
			key="search"></ms-input-text>
	</div>
	<div class="overflow-auto" [class]="listClass">
		<ul class="p-listbox-list">
			<ng-container
				*ngFor="
					let item of items | filter: 'name' : formGroup.get('search').value;
					let last = last
				">
				@if (item.notFound) {
					<li class="border p-listbox-item cursor-pointer">
						<small>Nenhum registro encontrado.</small>
					</li>
				} @else {
					<li
						class="p-listbox-item p-component cursor-pointer truncate"
						[ngClass]="{ 'bg-red-200 text-black': item === _selected, 'border-b': last }"
						(mouseover)="onMouseOver(item)"
						(click)="onSelected(item)">
						{{ item.name }}
					</li>
				}
			</ng-container>
		</ul>
	</div>
</div>
